<template>
	<div class="index">
		<el-container>
			<el-header height="80px">
				<Header></Header>
			</el-header>
			<el-main>
				<router-view id="main"></router-view>
			</el-main>
			<el-footer>
				<Footer></Footer>
			</el-footer>
		</el-container>
	</div>
</template>

<script>
	import Header from "@/components/Header.vue";
	import Footer from "@/components/Footer.vue";
	export default {
		name: "",
		data() {
			return {};
		},
		components: {
			Header,
			Footer,
		},
		methods: {},
		created() {},
	};
</script>

<style>
	html,
	body,
	.index {
		height: 100%;
	}
	.index .el-container {
		min-height: 100%;
		display: flex;
		flex-direction: column;
	}
	.index .el-main {
		flex: 1;
	}
	.index .el-header {
		padding: 0;
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 1900;
		flex: 0;
	}
	.index .el-main {
		width: 1200px;
		padding: 110px 0 0 0;
		margin: 0 auto;
		flex: 1;
	}
	.index .el-footer {
		margin: 30px auto auto auto;
		width: 100%;
		padding: 0;
		flex: 0;
	}
</style>
